import { FC } from 'react'
import { RenderIf } from 'components/RenderIf'
import { AgeProtectionP } from './styled'
import { isProductProtected } from 'featureSliced/shared/utils/isProductProtected'
import { getProtectedAge } from 'featureSliced/shared/utils/getProtectedAge'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

type AgeProtectionType = {
  product?: IProduct
}

export const AgeProtection: FC<AgeProtectionType> = ({ product }) => {
  return (
    <RenderIf condition={isProductProtected(product)}>
      <AgeProtectionP>{getProtectedAge(product)}</AgeProtectionP>
    </RenderIf>
  )
}
